import { htmlToPlainText } from '../components/AssessmentBuilder/ScreenBuilder/utils';

const VALID_OPTION_TEXT_ALIGNMENTS = new Set(['left', 'center', 'right']);

export const getOptionBoxWidth = (responseConfig = {}, scale = 1) => {
  const width = Number(responseConfig.optionBoxWidth);
  if (!Number.isFinite(width) || width <= 0) {
    return undefined;
  }

  return `${width * scale}px`;
};

export const getOptionTextAlign = (responseConfig = {}, fallback = 'center') => {
  const textAlign = responseConfig.optionTextAlign;
  return VALID_OPTION_TEXT_ALIGNMENTS.has(textAlign) ? textAlign : fallback;
};

export const estimateOptionBoxWidth = (content = '', responseConfig = {}) => {
  const fontSize = Number(responseConfig.optionFontSize) || 14;
  const padding = Number(responseConfig.optionPadding) || 8;
  const text = htmlToPlainText(content).replace(/\s+/g, '');

  return Math.ceil(text.length * fontSize * 0.5 + padding * 4 - 2);
};

export const getFallbackMeasuredOptionBoxWidth = (content, responseConfig = {}, measuredWidth) => {
  const configuredWidth = getOptionBoxWidth(responseConfig);
  if (configuredWidth) {
    return configuredWidth;
  }

  const measured = Number(measuredWidth);
  if (!Number.isFinite(measured) || measured <= 0) {
    return undefined;
  }

  const estimatedWidth = estimateOptionBoxWidth(content, responseConfig);
  return `${Math.max(measured, estimatedWidth)}px`;
};

export const getOptionButtonColors = (responseConfig = {}, isSelected = false) => {
  if (isSelected) {
    return {
      backgroundColor: responseConfig.btnSelectedBgColor || '#0d9488',
      color: responseConfig.btnSelectedTextColor || '#ffffff',
      borderColor: responseConfig.btnSelectedBorderColor || '#0d9488',
    };
  }

  const isFilled = responseConfig.buttonStyle === 'filled' || responseConfig.buttonStyle === 'solid';

  return {
    backgroundColor: responseConfig.btnBgColor || (isFilled ? '#0d9488' : '#ffffff'),
    color: responseConfig.btnTextColor || (isFilled ? '#ffffff' : '#0d9488'),
    borderColor: responseConfig.btnBorderColor || '#0d9488',
  };
};

export const getOptionBoxHeight = (responseConfig = {}, scale = 1) => {
  const height = Number(responseConfig.optionBoxHeight);
  if (!Number.isFinite(height) || height <= 0) {
    return undefined;
  }

  return `${height * scale}px`;
};

export const getOptionSpacing = (responseConfig = {}, fallback = 8) => {
  const raw = Number(responseConfig.spacing);
  if (!Number.isFinite(raw) || raw < 0) {
    return fallback;
  }
  return raw;
};

export const getOptionButtonSizingStyle = (responseConfig = {}, options = {}) => {
  const { scale = 1, fallbackTextAlign = 'center' } = options;
  const width = getOptionBoxWidth(responseConfig, scale);
  const height = getOptionBoxHeight(responseConfig, scale);
  const textAlign = getOptionTextAlign(responseConfig, fallbackTextAlign);

  // When an explicit height is set, switch the button to inline-flex so the
  // label is vertically centered inside the taller box. Default (no height)
  // keeps the original inline-block behavior so existing buttons are unaffected.
  const flexJustify = textAlign === 'left' ? 'flex-start'
    : textAlign === 'right' ? 'flex-end'
    : 'center';

  return {
    ...(width ? { width, minWidth: width } : {}),
    ...(height ? {
      height,
      minHeight: height,
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: flexJustify,
    } : {}),
    textAlign,
  };
};
